import { OnInit } from '@angular/core';
import { Message } from 'primeng/api';
import { Component } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { UserRegistrationService } from '../user-registration.service';
import { UserLoginService } from '../user-login.service';
import { CognitoUtil, CognitoCallback } from '../cognito.service';

export class NewPasswordUser {
    username: string;
    existingPassword: string;
    password: string;
}
/**
 * This component is responsible for displaying and controlling
 * the registration of the user.
 */
@Component({
    selector: 'app-newpassword',
    templateUrl: './newpassword.component.html'
})
export class NewPasswordComponent implements OnInit, CognitoCallback {
    email: string;
    registrationUser: NewPasswordUser;
    router: Router;
    errorMessages: Message[];

    constructor(public userRegistration: UserRegistrationService,
        public userService: UserLoginService,
        router: Router,
        private activatedRoute: ActivatedRoute) {
        this.router = router;
        this.onInit();
    }

    onInit() {
        this.registrationUser = new NewPasswordUser();
        this.errorMessages = [];
    }

    ngOnInit() {
        this.errorMessages = [];
        console.log('Checking if the user is already authenticated. If so, then redirect to the secure site');
        this.userService.isAuthenticated(this);
        this.activatedRoute.params.forEach((params: Params) => {
            if (params['email'] !== undefined) {
                this.email = params['email'];
            }
        });
    }

    onSave() {
        console.log(this.registrationUser);
        this.errorMessages = [];
        this.registrationUser.username = this.email;
        this.userRegistration.newPassword(this.registrationUser, this);
    }

    cognitoCallback(message: string, result: any) {
        if (message != null) { // error
            this.errorMessages = [({ severity: 'error', detail: message })];
            console.log('result: ' + message);
        } else { // success
            // move to the next step
            console.log('redirecting');
            this.router.navigate(['/'], {queryParams: {}});
        }
    }

    isLoggedIn(message: string, isLoggedIn: boolean) {
        if (isLoggedIn) {
            this.router.navigate(['/'], {queryParams: {}});
        }
    }
}
